import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, PageHeader } from '@/shared/components';
import { MotLookupForm } from './MotLookupForm';
import { MotHistoryPanel } from './MotHistoryPanel';
import type { MotLookupFormInputs } from '../schemas/motLookup.schema';

export const MotHistoryLookupPage: React.FC = () => {
  const [lookup, setLookup] = useState<{ vin?: string; vrm?: string } | null>(null);

  const handleSearch = (data: MotLookupFormInputs) => {
    setLookup({ vin: data.vin || undefined, vrm: data.vrm || undefined });
  };

  return (
    <div className="space-y-6">
      <PageHeader title="MOT History Lookup" subtitle="Search for MOT history by VIN or VRM" />
      <Card>
        <CardHeader>
          <CardTitle>Vehicle Search</CardTitle>
        </CardHeader>
        <CardContent>
          <MotLookupForm onSubmit={handleSearch} />
        </CardContent>
      </Card>
      {lookup && (
        <MotHistoryPanel vin={lookup.vin} vrm={lookup.vrm} showHeader />
      )}
    </div>
  );
};
